import { LocalizationLanguage, createLocalizationLanguage } from '../models/localization.model';

export const LOCALIZATION_LANGUAGES = {
  EN_US: createLocalizationLanguage('EN-US', 'English'),
  DE_DE: createLocalizationLanguage('DE-DE', 'Deutsch'),
  FR_FR: createLocalizationLanguage('FR-FR', 'Français'),
  RU_RU: createLocalizationLanguage('RU-RU', 'Русский'),
  PL_PL: createLocalizationLanguage('PL-PL', 'Polski'),
  ES_ES: createLocalizationLanguage('ES-ES', 'Español'),
  PT_BR: createLocalizationLanguage('PT-BR', 'Português (Brasil)'),
  IT_IT: createLocalizationLanguage('IT-IT', 'Italiano'),
  ZH_CN: createLocalizationLanguage('ZH-CN', '简体中文'),
  KO_KR: createLocalizationLanguage('KO-KR', '한국어'),
  JA_JP: createLocalizationLanguage('JA-JP', '日本語'),
  ZH_TW: createLocalizationLanguage('ZH-TW', '繁體中文'),
  ID_ID: createLocalizationLanguage('ID-ID', 'Bahasa Indonesia'),
  TR_TR: createLocalizationLanguage('TR-TR', 'Türkçe'),
  AR_SA: createLocalizationLanguage('AR-SA', 'العربية'),
};

export function getAllLocalizationLanguages(): LocalizationLanguage[] {
  return Object.values(LOCALIZATION_LANGUAGES);
}

export function getLanguagleById(id: string): LocalizationLanguage | undefined {
  return getAllLocalizationLanguages().find((x) => x.id === id);
}

export const formatDateForExcel = (date: Date): string => {
  return date.toISOString().replace('T', ' ').split('.')[0];
};

export const formatInternationalNumber = (value: number | null | undefined, maximumFractionDigits: number = 2): string => {
  if (value == null) return '';
  return new Intl.NumberFormat(navigator.language, {
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: 0,
    useGrouping: false,
  }).format(value);
};

export const getInternationalCsvSeparator = (): string => {
  const format = new Intl.NumberFormat(navigator.language).format(1.1);
  return format.includes(',') ? ';' : ',';
};
